import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, LANGUAGE_NAMES } from '../service/constants';

export function parseLanguageQueryParams(searchParams) {
    const langsParam = searchParams.get('langs');
    if (!langsParam) {
        return [];
    }
    
    const langs = langsParam.split(',').filter(lang => SUPPORTED_LANGUAGES.includes(lang));
    return langs;
}

export function serializeLanguageQueryParams(languages) {
    if (!languages || languages.length === 0) {
        return '';
    }
    
    return languages.join(',');
}

export function normalizeLanguageSelection(selectedLanguages) {
    if (!selectedLanguages || selectedLanguages.length === 0) {
        return [];
    }
    
    const allSupported = SUPPORTED_LANGUAGES.filter(lang => lang !== DEFAULT_LANGUAGE);
    const hasAll = allSupported.every(lang => selectedLanguages.includes(lang));
    
    if (hasAll && selectedLanguages.length === allSupported.length) {
        return [];
    }
    
    return selectedLanguages.filter(lang => lang !== DEFAULT_LANGUAGE);
}

export function pickDisplayLanguage(availableLanguages, selectedLanguages) {
    if (!availableLanguages || availableLanguages.length === 0) {
        return DEFAULT_LANGUAGE;
    }
    
    if (!selectedLanguages || selectedLanguages.length === 0) {
        return DEFAULT_LANGUAGE;
    }
    
    for (const selectedLang of selectedLanguages) {
        if (availableLanguages.includes(selectedLang)) {
            return selectedLang;
        }
    }
    
    return DEFAULT_LANGUAGE;
}

export function getLanguageDisplayName(lang) {
    return LANGUAGE_NAMES[lang] || lang.toUpperCase();
}

export function getLanguageBadge(lang) {
    return lang.toUpperCase();
}

export function sortLanguagesByOrder(languages) {
    const languageOrder = SUPPORTED_LANGUAGES;
    return languages.sort((a, b) => {
        const indexA = languageOrder.indexOf(a);
        const indexB = languageOrder.indexOf(b);
        if (indexA === -1 && indexB === -1) return 0;
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
    });
}
